import * as React from "react";

import { cn } from "@/lib/utils";

/** Saudi Riyal (SAR) currency symbol. Inherits font size + color. */
export function Riyal({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 67 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="SAR"
      className={cn("inline-block h-[0.85em] w-[0.76em] shrink-0 align-[-0.06em]", className)}
      {...props}
    >
      <path
        d="M66.667 60.8701C66.2264 64.4332 66.0323 65.9769 64.3867 69.4502L39.123 74.667C39.7038 70.9135 40.4781 68.0189 41.7363 66.2822L66.667 60.8701ZM31.4766 36.3008L39.0264 34.6621V10.8057C41.8394 7.64801 43.5684 6.23079 46.9639 4.43848V32.9385L66.667 28.6611C66.2264 32.2242 66.0322 33.7679 64.3867 37.2412L46.9639 40.9248V48.9365L66.667 44.7666C66.2264 48.3297 66.0322 49.8735 64.3867 53.3467L46.9639 56.9443V57.0195L39.0264 58.6602V42.6025L31.4766 44.1982V54.3184L31.3506 54.3438C29.6142 57.3887 27.1598 61.0463 24.7969 63.9668L0 68.6875C0.222341 65.4969 0.687099 63.7001 2.12988 60.4863L23.5391 55.8447V45.877L3.69531 50.0732C3.91765 46.8827 4.38241 45.0859 5.8252 41.8721L23.5391 38.0244V6.36816C26.3521 3.21046 28.0811 1.79233 31.4766 0V36.3008Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Riyal symbol + amount, kept on one line. */
export function Money({
  value,
  className,
  iconClassName,
}: {
  value: React.ReactNode;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <span className={cn("inline-flex items-baseline gap-1 whitespace-nowrap", className)}>
      <Riyal className={iconClassName} />
      <span>{value}</span>
    </span>
  );
}

/** For plain-text contexts (PDF, CSV, toasts, aria labels). */
export const SAR_TEXT = "SAR";
export const money = (value: React.ReactNode) => <Money value={value} />;
